import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="We’re halfway through 2020. Use this goal setting exercise to make it your best year yet article by Kat Medina, author of the book, The Joys of Jet Lag. A goal-setting exercise for mid-year progress. Accomplish your goals and resolutions." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Prepare yourself. You’re about to read a sentence that’s going to feel like reality just meat slapped you and hit you with a fat load of realization. Ready for it?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'We are halfway through the year.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'You might be thinking good riddance. After all, 2020 has been a shit storm of chaos. There’s no limit to what other unprecedented events we can add to this year’s wild ride. With so much going on in the world it can be easy to just throw in the towel and wait around for 2021.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I’m just curious though–how are those New Year’s resolutions that you set six months ago coming along?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Be honest, have you thought about them at all since January? I don’t blame you if you haven’t–we’ve kind of been dealing with a lot here. But let’s get real, most of us forget about our resolutions as soon as our New Year’s hangover wears off.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'June provides us with a second chance. Rather than wait until December to realize that you haven’t made any progress, use this halfway point as an opportunity to reevaluate what you want to do in 2020 and get back on track.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Start fresh by doing a quick goal setting exercise. Make a list of everything you want in life. Think of things you want to get, who you want to be, the sort of impact you want to make, and the experiences you want to have. Think of it as the ultimate bucket list that includes personal experiences, accomplishments, financial and professional achievements, and emotional and spiritual growth.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The biggest challenge with this exercise is to avoid limiting yourself. You might find your inner critic stepping in and telling you that you’re ridiculous and that what you want isn’t possible. When the critic shows up, say ‘thanks for trying to protect me from disappointment, but I don’t need you right now’ and then, make that particular goal even crazier and bigger. Go bananas and have fun with it.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Now let’s focus on 2020. Think of at least one goal for each of the following areas in your life: financial/professional, accomplishments/experiences, and personal growth. With each of the goals you come up with, think of why you want it. You can accomplish almost any ‘how’ if the ‘why’ is strong enough. What would that goal provide you with? How would it make you feel? Spend some time daydreaming about what your life would be like if you were able to pull them off before the end of the year.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Most people stop here. They think of something they want, daydream about it and then wait for life to take care of the rest. That’s not how it works, kemosabe. If you really want something, you can’t just hope your way to success–you have to take action.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'So the next step is to come up with three actions that you will take for each goal. Think of three things you need to do to make each goal a reality.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'For example, let’s say one of your goals was to get a raise. The three actions you might take are to make a list of all the value you have added to the company, come up with a strategy for how you plan to add even more value, and schedule a meeting with your boss.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The last step? Remove your thumb from your bum and take action. Right now, in this very moment, do something that will get you closer to your goals.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I’m going to tell you a secret. If you wait until later to make progress, you won’t do it. Secure your commitment to your goals by kicking them off with momentum and it will trigger something in your brain. Your cute little noggin will realize that, oh shit, this dude’s serious. And then it will start to look for ways to contribute to your success.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The next six months will go by fast, but if you do something each day that moves you closer to the goals you set, you’ll be amazed at how much you can accomplish. Do your future self a solid and start today.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/halfway.js